
import {PropType, defineComponent} from "vue";
import { Campaign } from "@/models/campaign";
import {mapActions} from "pinia";
import {AnalyticsAction, useAnalyticsStore} from "@/store/analytics.store";

export default defineComponent({
    data() {
        return {
            agentMessage: "",
            linkCopied: false,
        };
    },
    props: {
        campaign: {
            type: Object as PropType<Campaign>,
            required: true,
        },
    },
    mounted() {
        this.updatedAgentMessage();
        this.trackEvent('creationSuccessView', {
            ...this.$analytics.campaignParams(this.campaign),
        });
    },
    watch: {
        message() {
            this.updatedAgentMessage();
        },
    },
    computed: {
        isShownInNativeApp() {
            return typeof window.BeamsSDK !== 'undefined' && typeof window.BeamsSDK.finishScreenCTAClicked !== 'undefined';
        },
        shouldShowCTA() {
            return ((this.campaign.successLink && this.campaign.successLinkLabel) || this.isShownInNativeApp);
        },
        ctaLabel() {
            if (this.campaign.successLinkLabel) {
                return this.campaign.successLinkLabel;
            } else {
                return this.$t('survey.closeSurveyButton');
            }
        },
        message() {
            return this.campaign.successText || this.$t('survey.defaultAgentSuccessMessage');
        },
        isCopyLinkSupported() {
            return !!window.navigator.clipboard;
        },
        isWebShareAPIsupported() {
            return !!navigator.share;
        }
    },
    methods: {
        // analytics store
        ...mapActions(useAnalyticsStore, ['trackPageView']),
        ...mapActions(useAnalyticsStore, ['trackEvent']),
        ...mapActions(useAnalyticsStore, ['sendAnalyticsEvent']),

        updatedAgentMessage() {
            this.agentMessage = this.message;
        },
        share() {
            this.trackEvent('creationSuccessShareTapped', {
                ...this.$analytics.campaignParams(this.campaign),
            });

            if (navigator.share) {
                navigator.share({
                    title: this.campaign.promptText,
                    url: this.campaign.contributionURL,
                })
                    .then(() => {
                        console.log('Shared successfully!');
                    })
                    .catch((error) => {
                        console.error('Error sharing:', error);
                    });
                }
            else if (window.navigator.clipboard) {
                window.navigator.clipboard.writeText(this.campaign.contributionURL);

                this.linkCopied = true;
                setTimeout(() => {
                    this.linkCopied = false;
                }, 3000);
            } else {
                console.error('Web Share API not supported.');
            }
        },
        didOpenCTA(event: Event) {
            this.trackEvent('creationSuccessCTATapped', {
                ...this.$analytics.campaignParams(this.campaign),
            });

            this.sendAnalyticsEvent(AnalyticsAction.ThankYouLinkClicked, this.campaign.id);

            // In case when SDK is handling the final click, prevent URL from being opened
            if (typeof window.BeamsSDK !== 'undefined' && typeof window.BeamsSDK.finishScreenCTAClicked !== 'undefined') {
                event.preventDefault()
                window.BeamsSDK.finishScreenCTAClicked(this.campaign.successLink);
            }
        }
    },
});
